import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef  } from '@angular/material/dialog';
import { RoutingPositionOption } from '../../../model/sac-client.model';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-select-routing-position',
    templateUrl: './select-routing-position.component.html',
    styleUrls: ['./select-routing-position.component.scss'],
    standalone: false
})
export class SelectRoutingPositionComponent implements OnInit {

  selectedOptionId: number;

  formGroup = new FormGroup({
    selectedOption: new FormControl('', [Validators.required])
  });

  routingPositionOptions = new Array<RoutingPositionOption>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<SelectRoutingPositionComponent>
  ) {
    this.routingPositionOptions = this.data.routingPositionOptions;

    this.formGroup.valueChanges.subscribe(
      values => {
        this.selectedOptionId = values.selectedOption;
      }
    );

  }

  ngOnInit(): void {
  }

  public onSelectClicked() {
    this.dialog.close(this.selectedOptionId);
  }

}
